import { datajs, datajsAll } from '../shared/utils';
import { Dropdown } from 'bootstrap';
import axios from 'axios';

export default class NewsArchive {
	static getEmptyState() {
		return { categories: [], years: [] };
	}

	static init() {
		const archive = datajs('news-archive');
		const categoryFilterWrapper = datajs('category-filter-wrapper');
		const yearFilterWrapper = datajs('year-filter-wrapper');

		// Make sure all requred components exists
		if (!archive || !categoryFilterWrapper || !yearFilterWrapper) {
			return;
		}

		// Store the initial state for the popstate event later
		const initialFilterState = this.getInitialFilterState();

		// Apply the initial filter state to the currentFilterState variable
		NewsArchive.currentFilterState = this.getInitialFilterState();

		const updateCurrentFilterState = (e, filterType) => {
			// The updated filter value
			const filterValue = e.target.value;
			const filterText = e.target.closest('li').querySelector('label').innerHTML;

			// Add this filter if 'checked' and not included in the current filter state already
			if (e.target.checked && !NewsArchive.currentFilterState[filterType].includes(filterValue)) {
				NewsArchive.currentFilterState[filterType].push(filterValue);
				this.appendToSelectedFiltersList({
					type: filterType,
					value: filterValue,
					text: filterText,
				});
			}

			// Else, remove this filter from the current filter state
			else {
				NewsArchive.currentFilterState[filterType] = NewsArchive.currentFilterState[filterType].filter((value) => {
					return value !== filterValue;
				});
				this.removeFromSelectedFiltersList({
					type: filterType,
					value: filterValue,
				});
			}

			// Update the url
			if ('URLSearchParams' in window) {
				// Replace: page/[int]/
				var pathName = window.location.pathname.replace(/page\/\d+\//gi, '');

				var searchParams = new URLSearchParams(window.location.search);
				searchParams.set('ct', NewsArchive.currentFilterState.categories);
				searchParams.set('yr', NewsArchive.currentFilterState.years);

				var newRelativePathQuery = pathName + '?' + searchParams.toString() + window.location.hash;
				history.pushState(NewsArchive.currentFilterState, '', newRelativePathQuery);
			}

			// Apply the new filter state
			this.applyFilterState(NewsArchive.currentFilterState);
		};

		// Category filter
		if (categoryFilterWrapper) {
			const categoryFilterToggle = datajs('dropdown-toggle', categoryFilterWrapper);
			const categoryFilterItems = datajsAll('category-filter-item', categoryFilterWrapper);
			new Dropdown(categoryFilterToggle, { autoClose: 'outside' });

			categoryFilterItems.forEach((filterItem) => {
				// Update 'category' filter on click
				filterItem.addEventListener('click', function (e) {
					updateCurrentFilterState(e, 'categories');
				});
			});
		}

		// Year filter
		if (yearFilterWrapper) {
			const yearFilterToggle = datajs('dropdown-toggle', yearFilterWrapper);
			const yearFilterItems = datajsAll('year-filter-item', yearFilterWrapper);
			new Dropdown(yearFilterToggle, { autoClose: 'outside' });

			yearFilterItems.forEach((filterItem) => {
				// Update 'year' filter on click
				filterItem.addEventListener('click', function (e) {
					updateCurrentFilterState(e, 'years');
				});
			});
		}

		// Kick things off initially
		this.applyFilterState(NewsArchive.currentFilterState, false);
		this.bindEvents();

		// Enable back button
		window.addEventListener('popstate', (e) => {
			const categoryFilterWrapper = datajs('category-filter-wrapper');
			const yearFilterWrapper = datajs('year-filter-wrapper');
			const categoryFilterItems = datajsAll('category-filter-item', categoryFilterWrapper);
			const yearFilterItems = datajsAll('year-filter-item', yearFilterWrapper);

			let state = e.state;

			// Empty selected filters list
			datajs('selected-filters-list').innerHTML = '';

			// When there is no previous state
			if (!state) {
				const searchParams = new URLSearchParams(window.location.search);

				// If there were any params initialy, use the initial filter state
				if (searchParams.get('ct') || searchParams.get('yr')) {
					state = initialFilterState;
				} else {
					// Else use an empty state
					state = { categories: [], years: [] };
				}
			}

			if (state?.categories) {
				categoryFilterItems.forEach((filterItem) => {
					if (state.categories.includes(filterItem.value)) {
						filterItem.checked = true;
						this.appendToSelectedFiltersList({
							type: 'categories',
							value: filterItem.value,
							text: filterItem.closest('li').querySelector('label').innerHTML,
						});
					} else {
						filterItem.checked = false;
					}
				});
			}

			if (state?.years) {
				yearFilterItems.forEach((filterItem) => {
					if (state.years.includes(filterItem.value)) {
						filterItem.checked = true;
						this.appendToSelectedFiltersList({
							type: 'years',
							value: filterItem.value,
							text: filterItem.closest('li').querySelector('label').innerHTML,
						});
					} else {
						filterItem.checked = false;
					}
				});
			}

			NewsArchive.currentFilterState = state;
			this.applyFilterState(NewsArchive.currentFilterState);
		});
	}

	static loadNews() {
		const adminUrl = window.AppGlobals.adminUrl;
		const newsArchive = datajs('news-archive') || false;
		const gridContainer = datajs('news-posts-grid') || false;
		const paginationContainer = datajs('news-pagination') || false;

		if (!gridContainer || !newsArchive || !paginationContainer) {
			console.error('A valid grid container to populate with additional posts is not defined');
			return;
		}

		const action = newsArchive.dataset.action;
		const ct = newsArchive.dataset.ct;
		const yr = newsArchive.dataset.yr;
		const termTaxonomy = newsArchive.dataset.termTaxonomy;
		const termId = newsArchive.dataset.termId;

		const params = new URLSearchParams();
		params.append('action', action);
		params.append('ct', ct);
		params.append('yr', yr);
		params.append('term_taxonomy', termTaxonomy);
		params.append('term_id', termId);

		axios.post(`${adminUrl}admin-ajax.php`, params).then((res) => {
			gridContainer.innerHTML = res.data.data.posts || '<p class="text-center lead">Inga nyheter hittades</p>';
			paginationContainer.innerHTML = res.data.data.pagination || '';
		});
	}

	static bindEvents() {
		datajsAll('clear-filter-button').forEach((item) => {
			item.addEventListener('click', () => {
				NewsArchive.currentFilterState = this.getEmptyState();

				// Update the url
				if ('URLSearchParams' in window) {
					var searchParams = new URLSearchParams(window.location.search);
					searchParams.delete('ct');
					searchParams.delete('yr');
					var newRelativePathQuery = window.location.pathname + window.location.hash;
					history.pushState(NewsArchive.currentFilterState, '', newRelativePathQuery);
				}

				this.applyFilterState(NewsArchive.currentFilterState);
				this.uncheckFilterCheckboxes();
			});
		});

		// Remove specific filters when clicking on their labels outside the checkbox dropdowns
		datajs('selected-filters-list').addEventListener('click', (e) => {
			const { target } = e;

			if (!target.matches('button')) {
				return false;
			}

			const type = target.dataset.type;
			const removeValue = target.dataset.value;
			const categoryFilterWrapper = datajs('category-filter-wrapper');
			const yearFilterWrapper = datajs('year-filter-wrapper');

			// Category filter
			if (type === 'categories' && categoryFilterWrapper) {
				const categoryFilterItems = datajsAll('category-filter-item', categoryFilterWrapper);

				categoryFilterItems.forEach((filterItem) => {
					if (filterItem.value === removeValue) {
						filterItem.click();
					}
				});
			}

			// Year filter
			if (type === 'years' && yearFilterWrapper) {
				const yearFilterItems = datajsAll('year-filter-item', yearFilterWrapper);

				yearFilterItems.forEach((filterItem) => {
					if (filterItem.value === removeValue) {
						filterItem.click();
					}
				});
			}
		});
	}

	static applyFilterState(filterState, reloadNews = true) {
		// Remove any empty filters to prevent the filter function from failing
		let cleanedFilterState = { ...filterState };
		for (const key in cleanedFilterState) {
			if (Array.isArray(cleanedFilterState[key]) && !cleanedFilterState[key].length) delete cleanedFilterState[key];
		}

		// Handle "Clear filter"-button visibiliy
		const totalFilters = (cleanedFilterState?.categories?.length || 0) + (cleanedFilterState?.years?.length || 0);
		if (totalFilters > 0) {
			datajsAll('clear-filter-button').forEach((item) => item.classList.remove('d-none'));
		} else {
			datajsAll('clear-filter-button').forEach((item) => item.classList.add('d-none'));
		}

		// Update dropdown toggle text
		this.updateDropdownToggleText();

		// AJAX Load news
		const newsArchive = datajs('news-archive') || false;
		if (newsArchive && reloadNews) {
			newsArchive.dataset.ct = cleanedFilterState?.categories?.toString() || '';
			newsArchive.dataset.yr = cleanedFilterState?.years?.toString() || '';

			this.loadNews();
		}
	}

	static getInitialFilterState() {
		const categoryFilterWrapper = datajs('category-filter-wrapper');
		const yearFilterWrapper = datajs('year-filter-wrapper');
		const categoryFilterItems = datajsAll('category-filter-item', categoryFilterWrapper);
		const yearFilterItems = datajsAll('year-filter-item', yearFilterWrapper);

		let state = this.getEmptyState();

		if (categoryFilterItems) {
			categoryFilterItems.forEach((filterItem) => {
				if (filterItem.checked) {
					state.categories.push(filterItem.value);
				}
			});
		}

		if (yearFilterItems) {
			yearFilterItems.forEach((filterItem) => {
				if (filterItem.checked) {
					state.years.push(filterItem.value);
				}
			});
		}

		return state;
	}

	static uncheckFilterCheckboxes() {
		const categoryFilterWrapper = datajs('category-filter-wrapper');
		const yearFilterWrapper = datajs('year-filter-wrapper');
		const categoryFilterItems = datajsAll('category-filter-item', categoryFilterWrapper);
		const yearFilterItems = datajsAll('year-filter-item', yearFilterWrapper);

		if (categoryFilterItems) {
			categoryFilterItems.forEach((filterItem) => (filterItem.checked = false));
		}

		if (yearFilterItems) {
			yearFilterItems.forEach((filterItem) => (filterItem.checked = false));
		}

		// Empty selected filters list
		datajs('selected-filters-list').innerHTML = '';

		// Hide clear all filters button
		datajsAll('clear-filter-button').forEach((item) => {
			item.classList.add('d-none');
		});
	}

	static appendToSelectedFiltersList(obj) {
		const selectedFiltersContainer = datajs('selected-filters-list');
		const btn = document.createElement('button');

		btn.setAttribute('data-js', 'selected-filter-item');
		btn.setAttribute('class', 'btn btn-primary');
		btn.dataset.type = obj.type;
		btn.dataset.value = obj.value;
		btn.innerHTML = obj.text;

		selectedFiltersContainer.appendChild(btn);
	}

	static removeFromSelectedFiltersList(obj) {
		const selectedFilterItems = datajsAll('selected-filter-item');

		selectedFilterItems.forEach((item) => {
			if (obj.type === item.dataset.type && obj.value === item.dataset.value) {
				item.parentNode.removeChild(item);
			}
		});
	}

	static updateDropdownToggleText() {
		const categoryFilterWrapper = datajs('category-filter-wrapper');
		const categoriesDropdownToggle = datajs('dropdown-toggle', categoryFilterWrapper);
		const categoriesDropdownToggleTextElement = categoriesDropdownToggle.querySelector('.m-archiveFilters__filter__toggleBtn__count');
		const yearFilterWrapper = datajs('year-filter-wrapper');
		const yearsDropdownToggle = datajs('dropdown-toggle', yearFilterWrapper);
		const yearsDropdownToggleTextElement = yearsDropdownToggle.querySelector('.m-archiveFilters__filter__toggleBtn__count');

		// Categories
		if (NewsArchive.currentFilterState.categories.length === 0) {
			categoriesDropdownToggleTextElement.innerHTML = '';
		} else {
			categoriesDropdownToggleTextElement.innerHTML = `(${NewsArchive.currentFilterState.categories.length})`;
		}

		// Years
		if (NewsArchive.currentFilterState.years.length === 0) {
			yearsDropdownToggleTextElement.innerHTML = '';
		} else {
			yearsDropdownToggleTextElement.innerHTML = `(${NewsArchive.currentFilterState.years.length})`;
		}
	}
}

// Globals
NewsArchive.currentFilterState = null;
